import { SubHeaderPropsInterface } from './types';

export const SubHeader = ({
  leftWidget: LeftWidget,
  rightWidget: RightWidget,
  className = '',
}: SubHeaderPropsInterface) => {
  return (
    <div className={`flex flex-row justify-between ${className}`}>
      <div
        className={`${
          !RightWidget ? 'max-w-full' : 'max-w-[50%]'
        } overflow-x-auto`}
      >
        {LeftWidget && LeftWidget()}
      </div>
      <div
        className={`${
          !LeftWidget ? 'max-w-full' : 'max-w-[50%]'
        } flex items-start overflow-x-auto`}
      >
        {RightWidget && RightWidget()}
      </div>
    </div>
  );
};

export default SubHeader;
